
import Vue from 'vue';
import { Button, Select,Message,Carousel,
  CarouselItem, } from 'element-ui';

Vue.prototype.$message = Message;
Vue.use(Button)
Vue.use(Select)
Vue.use(Carousel)
Vue.use(CarouselItem)